var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAqueductIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 184 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.662 0V29.3967L122.441 54.4783L61.2207 29.3967L0 54.4783V25.0816L61.2207 0L122.441 25.0816L183.662 0Z",
    fill: "#3B516A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.662 55.4199V84.8167L122.441 109.898L61.2207 84.8167L0 109.898V80.5015L61.2207 55.4199L122.441 80.5015L183.662 55.4199Z",
    fill: "#3B516A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.662 110.711V140.108L122.441 165.189L61.2207 140.108L0 165.189V135.927L61.2207 110.711L122.441 135.927L183.662 110.711Z",
    fill: "#3B516A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqueductIcon);
export default __webpack_public_path__ + "static/media/aqueduct_icon.847fa3128c780c81e089874ae93b7644.svg";
export { ForwardRef as ReactComponent };